import { Badge, Group, Loader } from '@mantine/core';
import { useRef } from 'react';

import { DeclarationStatus } from '@e-origin/shared';

interface DeclarationStatusBadgeProps {
  status: DeclarationStatus;
}

export const DeclarationStatusBadge: React.FC<DeclarationStatusBadgeProps> = (props) => {
  const statusMap = useRef({
    [DeclarationStatus.ANALYSIS]: { label: 'Risk Analysis', color: '#ECCC38' },
    [DeclarationStatus.NOT_SENT]: { label: 'Not Sent', color: '#212121' },
    [DeclarationStatus.SENDING]: { label: 'Sending…', color: '#0F6298' },
    [DeclarationStatus.BEGATE_SENT]: { label: 'BE-Gate Sent', color: '#212121' },
    [DeclarationStatus.BEGATE_NOT_RELEASED]: { label: 'Be-Gate Not Released', color: '#FF3D3D' },
    [DeclarationStatus.BEGATE_RELEASED]: { label: 'Be-Gate Released', color: '#29AA47' },
    [DeclarationStatus.SENT]: { label: 'Sent', color: '#212121' },
    [DeclarationStatus.ACCEPTED]: { label: 'Validation In Progress', color: '#979797' },
    [DeclarationStatus.REJECTED]: { label: 'Rejected', color: '#FF6C0D' },
    [DeclarationStatus.IN_CONTROL]: { label: 'In Control', color: '#FF3D3D' },
    [DeclarationStatus.NOT_RELEASED]: { label: 'Not Released', color: '#FF3D3D' },
    [DeclarationStatus.RELEASED]: { label: 'Released', color: '#29AA47' },
    [DeclarationStatus.EXPORTED]: { label: 'Exported', color: '#29AA47' },
    [DeclarationStatus.INVALIDATED]: { label: 'Invalidated', color: '#0F6298' },
  });

  const entry = statusMap.current[props.status];
  if (props.status === DeclarationStatus.SENDING) {
    // While the declaration sits in SENDING (outbound complete, waiting for the
    // customs-events reducer to apply the SENT ack) signal in-flight state with
    // a spinner alongside the chip so users understand why no Send action is
    // offered for this row.
    return (
      <Group gap={6} wrap="nowrap">
        <Badge size="md" color={entry.color}>
          {entry.label}
        </Badge>
        <Loader size="xs" color={entry.color} />
      </Group>
    );
  }

  return (
    <Badge size="md" color={entry?.color}>
      {entry.label}
    </Badge>
  );
};
